import SearchField from '../../page-component/SearchField';

export const Search = ({
  onSearch,
  searchPlaceholder,
  backgroundColor,
  textColor,
  searchIconColor,
  clearButtonColor,
  initialValue,
}: {
  onSearch: ((value: string) => void) | null;
  searchPlaceholder?: string;
  backgroundColor?: string;
  textColor?: string;
  searchIconColor?: string;
  clearButtonColor?: string;
  initialValue?: string;
}) => {
  return (
    <SearchField
      placeholder={searchPlaceholder}
      onSearch={onSearch}
      backgroundColor={backgroundColor}
      textColor={textColor}
      searchIconColor={searchIconColor}
      clearButtonColor={clearButtonColor}
      initialValue={initialValue}
      data-test-id="page-search-field"
    />
  );
};
